import React, { ReactNode } from 'react';
import { Loader } from '@grubhubprod/gh-cookbook-react/dist';
import { useParams } from 'react-router-dom';
import { useFormContext } from 'react-hook-form/dist/index.ie11';
import { EmailInputLabel } from 'src/components/common/EmailInput/EmailInputLabel';
import { useCheckEmailAvailability } from 'src/common/features/DinersManagement/hooks/useCheckEmailAvailability';
import { errorMessages } from 'src/components/common/EmailInput/constants';
import { BaseEmailInput } from 'src/components/BaseEmailInput/BaseEmailInput';

export interface EmailServerValidatedControlProps {
  name: string;
  id: string;
  disabled?: boolean;
  disabledInfo?: ReactNode;
}

export const EmailServerValidatedControl: React.FC<EmailServerValidatedControlProps> =
  ({ name, id, disabled, disabledInfo }) => {
    const { corpid: corpId } = useParams<{ corpid: string }>();
    const {
      formState: { dirtyFields },
    } = useFormContext();

    const isDirty = dirtyFields[name];

    const { checkEmailAvailability, isLoading } =
      useCheckEmailAvailability(corpId);

    const validateEmailExists = async (
      email: string
    ): Promise<string | boolean> => {
      const isEmailAvailable = await checkEmailAvailability(email);

      return isEmailAvailable || errorMessages.notAvailable;
    };

    return (
      <BaseEmailInput
        name={name}
        id={id}
        aria-label="Email"
        label={
          <EmailInputLabel disabled={disabled} disabledInfo={disabledInfo} />
        }
        disabled={disabled}
        rules={{
          required: errorMessages.required,
          ...(isDirty && {
            validate: validateEmailExists,
          }),
        }}
        {...(isLoading && {
          suffixDecorator: <Loader size="sm" />,
        })}
      />
    );
  };
